module.exports = __webpack_public_path__ + "media/bootstrap-icons/badge-cc-fill-0301f49e.svg";